import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import PageLayout from '../../components/common/PageLayout';
import UserCard from '../../components/blocks/UserCard';
import RetailerAdminHeader from '../../components/common/RetailerAdminHeader';
import Button from '../../components/common/Button';
import Spinner from '../../components/common/Spinner';
import { AddUserModal } from '../../components/blocks/AddUserModal';
import ConfirmModal from '../../components/modals/ConfirmDeleteModal';
import {
  getAdminUsers,
  deleteAdminUsers,
  putAdminUsers,
  addUser,
  deleteAdminUsersNotRegistered,
  putAdminUsersNotRegistered,
  unblockUser,
} from '../../store/actions/adminUsers';
import { fullName } from '../../utils/textHelper';

function UsersPageContainer(props) {
  const { getUsers, currentUser } = props;

  const [addUserOpen, setAddUserOpen] = useState(false);
  const [confirmModal, setConfirmModal] = useState({
    open: false,
  });

  useEffect(() => {
    getUsers();
  }, [getUsers]);

  const confirmActionModal = (user, actionType) => {
    const action = actionType === 'delete' ? deleteUser : unblockUser;
    const text =
      actionType === 'delete'
        ? `Are you sure you want to delete this user? (${fullName(user)})`
        : `Are you sure you wish to unblock ${user.email}?`;

    setConfirmModal({
      open: true,
      text,
      userId: user.id,
      action,
    });
  };

  const closeModal = () => {
    setConfirmModal({ open: false });
  };

  const unblockUser = (userId) => {
    closeModal();
    props.unblockUser(userId, 'retailer');
  };

  const deleteUser = (userId) => {
    closeModal();
    props.deleteUser(userId);
  };

  const addUserStyle = {
    textAlign: 'right',
    marginBottom: '10px',
  };

  const pageHero = <RetailerAdminHeader title="Users" retailerId={props.retailerId} />;
  const isAuthorized = currentUser?.role === 'admin' && currentUser?.isSuperAdmin;
  return (
    <PageLayout top={pageHero}>
      {props.isLoading ? (
        <Spinner />
      ) : (
        <>
          <div style={addUserStyle}>
            <Button type="button" text="Add User +" onClick={() => setAddUserOpen(true)} />
          </div>

          {props.data.map((value) => (
            <UserCard
              key={value.email}
              data={value}
              submit={props.submit}
              openConfirmModal={confirmActionModal}
              isAuthorized={isAuthorized}
              submitUserNotRegistered={props.submitUserNotRegistered}
              deleteUserNotRegistered={props.deleteUserNotRegistered}
              isCurrentUser={value.user && currentUser?.id === value.user.id}
            />
          ))}

          <AddUserModal open={addUserOpen} onClose={() => setAddUserOpen(false)} addUser={props.addUser} />

          <ConfirmModal
            open={confirmModal.open}
            text={confirmModal.text}
            objectId={confirmModal.userId}
            onConfirm={confirmModal.action}
            onCancel={closeModal}
          />
        </>
      )}
    </PageLayout>
  );
}

const mapStateToProps = (state) => {
  const { data, isLoading } = state.adminUsers;
  const { retailerId, user } = state.role;

  return {
    data,
    isLoading,
    retailerId,
    currentUser: user,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getUsers: () => dispatch(getAdminUsers()),
  addUser: (data) => dispatch(addUser(data)),
  submit: (userId, permissions, data) => dispatch(putAdminUsers(userId, permissions, data)),
  deleteUser: (userId) => dispatch(deleteAdminUsers(userId)),
  deleteUserNotRegistered: (email) => dispatch(deleteAdminUsersNotRegistered(email)),
  submitUserNotRegistered: (email, permissions, data) => dispatch(putAdminUsersNotRegistered(email, permissions, data)),
  unblockUser: (userId, role) => dispatch(unblockUser(userId, role)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UsersPageContainer);

UsersPageContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  getUsers: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  submit: PropTypes.func.isRequired,
  deleteUser: PropTypes.func.isRequired,
  addUser: PropTypes.func.isRequired,
  deleteUserNotRegistered: PropTypes.func.isRequired,
  submitUserNotRegistered: PropTypes.func.isRequired,
  currentUser: PropTypes.object,
};
